import { render, staticRenderFns } from "./EocViewSummaryInsurance.vue?vue&type=template&id=45e712f9&"
import script from "./EocViewSummaryInsurance.vue?vue&type=script&lang=js&"
export * from "./EocViewSummaryInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports